@if (languageBoxType === 'select-box') {
  <ion-grid>
    <ion-row>
      <ion-col size-xs="2" size-md="4"></ion-col>
      <ion-col size-xs="8" size-md="4">
        @if (form) {
          <form [formGroup]="form">
            <ion-select
              label="{{ 'language_select' | translate }}"
              formControlName="language"
              ngDefaultControl
            >
              @for (language of languages; track language.id) {
                <ion-select-option [value]="language.id">
                  {{ language.name }}
                </ion-select-option>
              }
            </ion-select>
          </form>
        }
      </ion-col>
      <ion-col size-xs="2" size-md="4"></ion-col>
    </ion-row>
  </ion-grid>
}

<!-- inline language selection layout  -->
@if (languageBoxType === 'inline-box') {
  <div class="language-box">
    <ul>
      @for (language of languages; track language.id) {
        <li
          [ngClass]="{ active: language.id === defaultLanguageId }"
          (click)="changeLanguage(language.id)"
        >
          {{ language.name }}
          <div class="line"></div>
        </li>
      }
    </ul>
  </div>
}
